import { Link } from 'react-router-dom';

interface BrandNameProps {
  /** Additional classes for the container (font size, weight, color for "Code" part) */
  className?: string;
  /**
   * Render the brand name as a link. Default is plain text so existing
   * logo/header usages are unchanged. Set this in body copy / guide prose so
   * readers who click the brand name actually go somewhere (PostHog showed
   * heavy dead-clicking on un-linked "CodePulse" mentions in guides).
   */
  link?: boolean;
  /** Link destination when `link` is set. Defaults to the homepage. */
  to?: string;
}

/** "Code" inherits the parent color, "Pulse" uses the green gradient from logo.svg */
function BrandText() {
  return (
    <>
      Code<span className="brand-pulse">Pulse</span>
    </>
  );
}

/**
 * CodePulse brand name with gradient styling on "Pulse".
 * Pass `link` to render it as a Router link (used in guide/body prose).
 */
export default function BrandName({ className = '', link = false, to = '/' }: BrandNameProps) {
  if (link) {
    return (
      <Link to={to} className={`hover:underline ${className}`.trim()}>
        <BrandText />
      </Link>
    );
  }

  return (
    <span className={className}>
      <BrandText />
    </span>
  );
}
